<template>
  <div class="header">
    <b-container>
      <b-row class="header-items">
        <b-col cols="1" class="header-items__icon mr-auto">
          <b-navbar-brand><img :src="image_src"></b-navbar-brand>
        </b-col>
        <b-col cols="6" class="ml-auto pull-left" style="width: 480px;">
          <b-navbar toggleable="md">
            <b-navbar-nav>
              <b-nav-item :to="item.path" v-for="item in tab_states" :key="item.name"
                          @click="ontab(item.path)"
                          class="head-items__item"
                          :class="{ 'head-items__item--select_header': item.isActive }">
                <span
                  :class="{ 'head-items__item--select_tab': item.isActive }">{{ item.name }}</span>
              </b-nav-item>
            </b-navbar-nav>
          </b-navbar>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>

export default {
  data() {
    return {
      image_src: require("../../img/header_icon.png"),
      tab_states: [],
    }
  },

  methods: {
    ontab(path) {
      this.$router.push(path);
    },

    head_display() {
      const hrefs = location.href.split('/');
      const url = hrefs[hrefs.length - 1];

      this.tab_states = [
        {
          "name": "ダッシュボード",
          "path": "dashboard",
          "isActive": url === "dashboard" ? true : false
        }, {
          "name": "予測シミュレーション",
          "path": "predict",
          "isActive": url === "predict" ? true : false
        }, {
          "name": "設定",
          "path": "setting",
          "isActive": url === "setting" ? true : false
        },
      ];
    },
  },

  created() {
    this.head_display();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.header {
  height: 50px;
  width: 100%;
  background-color: #ffffff;

  .header-items {
    width: 1050px;
    margin-left: auto;
    margin-right: auto;
    background-color: #ffffff;

    .header-items__icon {
      padding-top: 2px;
    }

    .head-items__item {
      margin-bottom: -8px;
      width: 160px;
      text-align: center;
      font-family: HiraginoSans-W6;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;

      .head-items__item--select_tab {
        color: #0b7bfe;
      }
    }

    .head-items__item--select_header {
      border-bottom: inset 4px;
      border-color: #0b7bfe;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pageheader.vue?328b58e9